/** True when admin business category is Skates (matches sidebar + route guard). */
export function isSkatesCategory(value) {
  const n = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
  return n === "skates" || n.includes("skates");
}

export function shouldShowSkatesDashboard(user) {
  if (!user?.main_id) return false;
  return isSkatesCategory(user.category);
}
